export var borderRadius = {
    zero: 0,
    s: '2px',
    m: '4px',
    l: '8px',
    circle: '999px',
};
export default borderRadius;
